/* eslint-disable no-undef */
import properties from '.././../../static/properties/appConfig'
import store from '../../store'

function permitted (logic, roles, entitlements) {
  function hasAny (superset, subset) {
    return !_.isEmpty(_.intersection(subset, superset))
  }
  function hasAll (superset, subset) {
    return _.isEmpty(_.difference(subset, superset))
  }
  function has (obj, superset) {
    if (obj) {
      if (obj.all) {
        return hasAll(superset, obj.all)
      } else if (obj.any) {
        return hasAny(superset, obj.any)
      } else {
        return false
      }
    } else {
      return true
    }
  }

  var rc = false
  var hasRoles = false
  var hasEntitlements = false

  if (logic) {
    if (logic.all) {
      hasRoles = has(logic.all.roles, roles)
      hasEntitlements = has(logic.all.entitlements, entitlements)
      rc = hasRoles && hasEntitlements
    } else if (logic.any) {
      hasRoles = has(logic.any.roles, roles)
      hasEntitlements = has(logic.any.entitlements, entitlements)
      rc = hasRoles || hasEntitlements
    } else {
      rc = false
    }
  } else {
    rc = true
  }
  return rc
}

const userData = JSON.parse(localStorage.getItem('userData'))
// console.log(userData, 'userData sb')
if (userData) {
  localStorage.setItem('REFRESH', true)
} else {
  localStorage.setItem('REFRESH', false)
}

const canAccess = () => {
  var userInfo = JSON.parse(localStorage.getItem('userData'))
  if (userInfo) {
    if (userInfo.roleList.includes('Materials Manager')) {
      return true
    } else {
      return false
    }
  }
}
const canAccessPairinig = () => {
  var userInfo = JSON.parse(localStorage.getItem('userData'))
  if (userInfo) {
    if (userInfo.roleList.includes('Maintenance User')) {
      return true
    } else {
      return false
    }
  }
}
const canAccessNoRole = () => {
  var userInfo = JSON.parse(localStorage.getItem('userData'))
  if (userInfo) {
    if (userInfo.roleList.length === 0) {
      return true
    } else if (userInfo.roleList.includes('Security Administrator')) {
      return true
    } else {
      return false
    }
  }
}
const isPermitted = (logic) => {
  if (store.getters.getUserInfo) { return permitted(logic, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}
const isOrgAdmin = () => {
  if (store.getters.getUserInfo) { return permitted(properties.properties.orgAdminLogic, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}
const canGrantAppToUser = () => {
  if (store.getters.getUserInfo) { return permitted(properties.properties.grantAppToUserLogic, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}
const canGrantAppToOrg = () => {
  if (store.getters.getUserInfo) { return permitted(properties.properties.grantAppToOrgLogic, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}
const accessByAnyAdmin = () => {
  if (store.getters.getUserInfo) { return permitted(properties.properties.accessByAnyAdmin, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}
const globalSearch = () => {
  if (store.getters.getUserInfo) { return permitted(properties.properties.globalSearch, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}
const accessToSecurityAndExchangeAdmins = () => {
  if (store.getters.getUserInfo) { return permitted(properties.properties.accessToSecurityAndExchangeAdmins, store.getters.getUserInfo.roleList, store.getters.getUserInfo.entitlementList) }
}

export default {
  canAccess,
  canAccessPairinig,
  canAccessNoRole,
  isPermitted,
  isOrgAdmin,
  canGrantAppToUser,
  canGrantAppToOrg,
  accessByAnyAdmin,
  globalSearch,
  accessToSecurityAndExchangeAdmins
}



// WEBPACK FOOTER //
// ./src/plugins/factory/BaseExtensions.js